import {
  cubeProCountMeasure,
  cubeProIsProMember,
  cubeProLoyaltyJoinedAt,
  cubeProMonthDataKey,
  cubeProRegionDimension,
} from "./cubeProContractorsModel";
import { type CubeFilter, type CubeLoadQuery } from "./cubeQueryTypes";
import { fetchCubeLoad, getCubeDataOrThrow } from "./fetchCubeLoad";
import { type ProContractorRow, parseProContractorRows } from "./parseProContractorRows";

const buildProOrder = (): [string, "asc" | "desc"][] => {
  return [
    [cubeProLoyaltyJoinedAt, "asc"],
    [cubeProRegionDimension, "asc"],
  ];
};

export const loadProContractorsByMonthRegion = async (params: {
  cubeLoad: (query: CubeLoadQuery) => Promise<unknown>;
  regionFilter?: string | null;
}): Promise<ProContractorRow[]> => {
  const { cubeLoad, regionFilter } = params;
  const order = buildProOrder();
  const filters: CubeFilter[] = [{ member: cubeProIsProMember, operator: "equals", values: [true] }];
  const regionTrimmed = regionFilter?.trim();
  if (regionTrimmed !== undefined && regionTrimmed.length > 0) {
    filters.push({ member: cubeProRegionDimension, operator: "equals", values: [regionTrimmed] });
  }
  const json = await fetchCubeLoad({
    cubeLoad,
    query: {
      measures: [cubeProCountMeasure],
      dimensions: [cubeProRegionDimension],
      timeDimensions: [{ dimension: cubeProLoyaltyJoinedAt, granularity: "month" }],
      filters,
      order,
      limit: 5000,
    },
  });
  const rows = getCubeDataOrThrow(json);
  return parseProContractorRows({
    rows,
    proCountMeasure: cubeProCountMeasure,
    proLoyaltyJoinedAt: cubeProLoyaltyJoinedAt,
    proRegionDimension: cubeProRegionDimension,
    proMonthDataKey: cubeProMonthDataKey,
  });
};
